import React, { Component } from "react";
import { Container, Row, Col, Image } from 'react-bootstrap';
import { colorPens } from "../utils/colors";
import RecipeCard from "./RecipeCard";
import { Adsense } from '@ctrl/react-adsense';

// import { IconButton } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

class RecipeList extends Component {
    constructor(props) {
        super(props);

        // this.state = {
        //     recipes: [],
        // }
    }

    // async componentDidMount() {
    // }

    renderRecipes() {
        let recipeList = [];
        if (this.props.recipes !== undefined && this.props.recipes !== null) {
            if (Object.keys(this.props.recipes).length > 0) {
                this.props.recipes.forEach((recipe) => {
                    let title = `${recipe.title}`;
                    let image = `${recipe.image}`;
                    let author = `${recipe.author}`;
                    let description = `${recipe.description}`;
                    let url = `${recipe.url}`;

                    recipeList.push(<RecipeCard title={title} image={image} author={author} description={description} link={url} />);
                });
            } else {
                recipeList.push(<Container>
                    <Row className="justify-content-center align-items-center">
                        <Col md={12}>
                            <ErrorOutlineIcon fontSize="small" color="primary" /> Sorry, we couldn’t find anything. Please provide a <a href="/help/feedback">feedback</a> if this doesn't feel right to you.
                        </Col>
                        <br /><br />
                    </Row></Container>);
            }
        }

        return recipeList;
    }

    render() {
        return (
            <Container fluid>
                <Row className="justify-content-center align-items-top">
                    {/* <Col md={1}>[[ Ad Here ]]</Col> */}
                    <Col md={10}>
                        {/* https://www.match2one.com/blog/standard-banner-sizes/ */}
                        <a href="/help/feedback"><Image alt="BeedMeer" src={process.env.PUBLIC_URL + '/images/banners/Advertise Here (728x90).png'} rounded fluid /></a>
                        <br /><br />
                        {this.props.paginationBar}
                        <br />
                        <Row>
                            <Col>
                                {this.renderRecipes()}
                            </Col>
                        </Row>
                        {this.props.paginationBar}
                    </Col>
                    <Col md={2}>
                        {/* <span style={{ color: colorPens.secondary, position: 'fixed', right: '20px', bottom: '100px' }}>
                            <a href="/help/feedback"><Image alt="BeedMeer" src={process.env.PUBLIC_URL + '/images/banners/Find Perfect Patterns (160x600).png'} fluid /></a>
                        </span> */}
                        <span>
                            <Adsense
                                client='ca-pub-3148902109066365'
                                slot='1710436871'
                                style={{ display: 'block' }}
                                format='auto'
                                responsive='true'
                            />
                        </span>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default RecipeList;